import { YhBox } from "@/components/YhBox";
import '../approval.less'
import { useApprovalModel } from '../approvalModel';
import { clone } from 'lodash';
import { useState } from 'react';
import { PlusSquareOutlined } from "@ant-design/icons";

// 定义审批类型数据结构
interface ApprovalItem {
  title: string;
  key: number;
}

// 基础样式
const baseItemStyles = {
  padding: '8px 12px',
  display: 'flex',
  flexdirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '4px',
  transition: 'background-color 0.2s, color 0.2s',
  fontWeight: 'normal' as const
};

// 选中状态样式
const selectedItemStyles = {
  ...baseItemStyles,
  backgroundColor: '#3e67f41a',
  color: '#3e67f4',
  fontWeight: '500' as const
};

// 普通状态样式
const normalItemStyles = {
  ...baseItemStyles,
  backgroundColor: 'transparent',
  color: 'inherit'
};

// 悬停状态样式
const hoverItemStyles = {
  ...normalItemStyles,
  backgroundColor: '#f0f2f5'
};

export const Left = () => {
  const {
    selectedShop, setSelectedShop, setSelectType
  } = useApprovalModel();

  // 为每个项目单独管理hover状态
  const [hoveredKey, setHoveredKey] = useState<number | null>(null);

  // 审批类型数据
  const approvalItems: ApprovalItem[] = [
    {
      title: '报修审批',
      key: 0,
    },
    // {
    //   title: '外修审批',
    //   key: 1,
    // },
    // {
    //   title: '外修审批(特殊)',
    //   key: 2,
    // },
    // {
    //   title: '采购审批',
    //   key: 3,
    // },
    // {
    //   title: '询价审批',
    //   key: 4,
    // },
    // {
    //   title: '采购入库审批',
    //   key: 5,
    // },
    // {
    //   title: '维修加项审批',
    //   key: 6,
    // }
  ];

  // 处理项目点击（选中操作）
  const handleItemClick = (item: ApprovalItem) => {
    const selectNode = clone(item);
    setSelectedShop(selectNode);
  };

  // 处理图标点击（单独操作）
  const handleIconClick = (e: React.MouseEvent, item: ApprovalItem) => {
    // 阻止事件冒泡，避免触发项目点击
    e.stopPropagation();

    setSelectType('add')
  };

  // 获取项目样式
  const getItemStyles = (item: ApprovalItem) => {
    const isSelected = selectedShop?.key === item.key;
    const isHovered = hoveredKey === item.key;

    if (isSelected) {
      return selectedItemStyles;
    }
    return isHovered ? hoverItemStyles : normalItemStyles;
  };

  return (
    <YhBox style={{ width: "100%", height: "100%" }} title="审批配置">
      <div style={{ padding: '10px 20px' }}>
        {approvalItems.map((item, index) => (
          <div
            key={item.key}
            style={getItemStyles(item)}
            onClick={() => handleItemClick(item)}
            onMouseEnter={() => setHoveredKey(item.key)}
            onMouseLeave={() => setHoveredKey(null)}
          >
            <span>{item.title}</span>
            {/* {(index == 0 || index == 3) && <PlusSquareOutlined
              style={{
                fontSize: '22px',
                color: '#3e67f4',
                cursor: 'pointer',
                transition: 'transform 0.2s',
                transform: hoveredKey === item.key ? 'scale(1.1)' : 'scale(1)'
              }}
              onClick={(e) => handleIconClick(e, item)}
            />} */}
          </div>
        ))}
      </div>
    </YhBox>
  )
}
